// DO NOT EDIT THIS FILE DIRECTLY. Autogenerated by "yarn squoosh"
export type SquooshedPictureKey =
  | 'illustrations/about-you'
  | 'illustrations/allPets'
  | 'illustrations/appointee'
  | 'illustrations/authority'
  | 'illustrations/blood'
  | 'illustrations/cat'
  | 'illustrations/catPet'
  | 'illustrations/cockPet'
  | 'illustrations/coffin'
  | 'illustrations/cornerstone-vault'
  | 'illustrations/crowd'
  | 'illustrations/dashlaneModal'
  | 'illustrations/death'
  | 'illustrations/deputy'
  | 'illustrations/device'
  | 'illustrations/digitalExecutorOrders'
  | 'illustrations/dog'
  | 'illustrations/dogPet'
  | 'illustrations/dogWithVet'
  | 'illustrations/dollar-skyscrapers'
  | 'illustrations/estate-planning-family'
  | 'illustrations/executors'
  | 'illustrations/family'
  | 'illustrations/file'
  | 'illustrations/financing'
  | 'illustrations/fishPet'
  | 'illustrations/flower'
  | 'illustrations/funeralHero'
  | 'illustrations/future-message'
  | 'illustrations/goodtrust-network'
  | 'illustrations/hamsterPet'
  | 'illustrations/handshake'
  | 'illustrations/handsOnLaptop'
  | 'illustrations/happyDance'
  | 'illustrations/health-agent'
  | 'illustrations/horsePet'
  | 'illustrations/identity'
  | 'illustrations/life-stories'
  | 'illustrations/locked'
  | 'illustrations/lockedSafety'
  | 'illustrations/medicalHero'
  | 'illustrations/memorialize'
  | 'illustrations/memories'
  | 'illustrations/mirror'
  | 'illustrations/mirrorAlt'
  | 'illustrations/mousePet'
  | 'illustrations/oldBlackMan'
  | 'illustrations/parrotPet'
  | 'illustrations/petHero'
  | 'illustrations/physician'
  | 'illustrations/poaHero'
  | 'illustrations/printer'
  | 'illustrations/property'
  | 'illustrations/rabbitPet'
  | 'illustrations/raccoonPet'
  | 'illustrations/ready'
  | 'illustrations/review'
  | 'illustrations/rip'
  | 'illustrations/safe'
  | 'illustrations/selectPersonWoman'
  | 'illustrations/signatures'
  | 'illustrations/snakePet'
  | 'illustrations/testament'
  | 'illustrations/trusted-contact'
  | 'illustrations/twoGirlsOneLaptop'
  | 'illustrations/vault'
  | 'illustrations/vault-2'
  | 'illustrations/vet'
  | 'illustrations/vetTall'
  | 'illustrations/what'
  | 'illustrations/willHero'
  | 'illustrations/witness'

export type PictureSource = {
  type: string
  srcset: string
}

export type SquooshedPictureData = {
  fallbackSrc: string
  sources: PictureSource[]
}

export type SquooshedPictures = Record<SquooshedPictureKey, SquooshedPictureData>

export const squooshedPictures: SquooshedPictures = {
  'illustrations/about-you': {
    fallbackSrc: '/images/illustrations/about-you@750w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/about-you@320w.png 320w, /images/illustrations/about-you@750w.png 750w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/about-you@320w.webp 320w, /images/illustrations/about-you@750w.webp 750w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/allPets': {
    fallbackSrc: '/images/illustrations/allPets@320w.png',
    sources: [
      { srcset: '/images/illustrations/allPets@320w.png 320w', type: 'image/png' },
      {
        srcset:
          '/images/illustrations/allPets@320w.webp 320w, /images/illustrations/allPets@640w.webp 640w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/appointee': {
    fallbackSrc: '/images/illustrations/appointee@750w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/appointee@320w.png 320w, /images/illustrations/appointee@750w.png 750w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/appointee@320w.webp 320w, /images/illustrations/appointee@750w.webp 750w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/authority': {
    fallbackSrc: '/images/illustrations/authority@750w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/authority@320w.png 320w, /images/illustrations/authority@750w.png 750w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/authority@320w.webp 320w, /images/illustrations/authority@750w.webp 750w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/blood': {
    fallbackSrc: '/images/illustrations/blood@750w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/blood@320w.png 320w, /images/illustrations/blood@750w.png 750w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/blood@320w.webp 320w, /images/illustrations/blood@750w.webp 750w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/cat': {
    fallbackSrc: '/images/illustrations/cat@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/cat@320w.png 320w, /images/illustrations/cat@640w.png 640w, /images/illustrations/cat@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/cat@320w.webp 320w, /images/illustrations/cat@640w.webp 640w, /images/illustrations/cat@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/catPet': {
    fallbackSrc: '/images/illustrations/catPet@320w.png',
    sources: [
      { srcset: '/images/illustrations/catPet@320w.png 320w', type: 'image/png' },
      { srcset: '/images/illustrations/catPet@320w.webp 320w', type: 'image/webp' },
    ],
  },
  'illustrations/cockPet': {
    fallbackSrc: '/images/illustrations/cockPet@320w.png',
    sources: [
      { srcset: '/images/illustrations/cockPet@320w.png 320w', type: 'image/png' },
      { srcset: '/images/illustrations/cockPet@320w.webp 320w', type: 'image/webp' },
    ],
  },
  'illustrations/coffin': {
    fallbackSrc: '/images/illustrations/coffin@750w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/coffin@320w.png 320w, /images/illustrations/coffin@750w.png 750w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/coffin@320w.webp 320w, /images/illustrations/coffin@750w.webp 750w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/cornerstone-vault': {
    fallbackSrc: '/images/illustrations/cornerstone-vault@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/cornerstone-vault@320w.png 320w, /images/illustrations/cornerstone-vault@640w.png 640w, /images/illustrations/cornerstone-vault@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/cornerstone-vault@320w.webp 320w, /images/illustrations/cornerstone-vault@640w.webp 640w, /images/illustrations/cornerstone-vault@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/crowd': {
    fallbackSrc: '/images/illustrations/crowd@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/crowd@320w.png 320w, /images/illustrations/crowd@640w.png 640w, /images/illustrations/crowd@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/crowd@320w.webp 320w, /images/illustrations/crowd@640w.webp 640w, /images/illustrations/crowd@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/dashlaneModal': {
    fallbackSrc: '/images/illustrations/dashlaneModal@320w.png',
    sources: [
      { srcset: '/images/illustrations/dashlaneModal@320w.png 320w', type: 'image/png' },
      {
        srcset:
          '/images/illustrations/dashlaneModal@320w.webp 320w, /images/illustrations/dashlaneModal@640w.webp 640w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/death': {
    fallbackSrc: '/images/illustrations/death@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/death@320w.png 320w, /images/illustrations/death@640w.png 640w, /images/illustrations/death@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/death@320w.webp 320w, /images/illustrations/death@640w.webp 640w, /images/illustrations/death@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/deputy': {
    fallbackSrc: '/images/illustrations/deputy@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/deputy@320w.png 320w, /images/illustrations/deputy@640w.png 640w, /images/illustrations/deputy@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/deputy@320w.webp 320w, /images/illustrations/deputy@640w.webp 640w, /images/illustrations/deputy@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/device': {
    fallbackSrc: '/images/illustrations/device@636w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/device@320w.png 320w, /images/illustrations/device@636w.png 636w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/device@320w.webp 320w, /images/illustrations/device@636w.webp 636w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/digitalExecutorOrders': {
    fallbackSrc: '/images/illustrations/digitalExecutorOrders@640w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/digitalExecutorOrders@320w.png 320w, /images/illustrations/digitalExecutorOrders@640w.png 640w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/digitalExecutorOrders@320w.webp 320w, /images/illustrations/digitalExecutorOrders@640w.webp 640w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/dog': {
    fallbackSrc: '/images/illustrations/dog@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/dog@320w.png 320w, /images/illustrations/dog@640w.png 640w, /images/illustrations/dog@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/dog@320w.webp 320w, /images/illustrations/dog@640w.webp 640w, /images/illustrations/dog@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/dogPet': {
    fallbackSrc: '/images/illustrations/dogPet@320w.png',
    sources: [
      { srcset: '/images/illustrations/dogPet@320w.png 320w', type: 'image/png' },
      { srcset: '/images/illustrations/dogPet@320w.webp 320w', type: 'image/webp' },
    ],
  },
  'illustrations/dogWithVet': {
    fallbackSrc: '/images/illustrations/dogWithVet@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/dogWithVet@320w.png 320w, /images/illustrations/dogWithVet@640w.png 640w, /images/illustrations/dogWithVet@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/dogWithVet@320w.webp 320w, /images/illustrations/dogWithVet@640w.webp 640w, /images/illustrations/dogWithVet@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/dollar-skyscrapers': {
    fallbackSrc: '/images/illustrations/dollar-skyscrapers@750w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/dollar-skyscrapers@320w.png 320w, /images/illustrations/dollar-skyscrapers@750w.png 750w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/dollar-skyscrapers@320w.webp 320w, /images/illustrations/dollar-skyscrapers@750w.webp 750w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/estate-planning-family': {
    fallbackSrc: '/images/illustrations/estate-planning-family@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/estate-planning-family@320w.png 320w, /images/illustrations/estate-planning-family@640w.png 640w, /images/illustrations/estate-planning-family@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/estate-planning-family@320w.webp 320w, /images/illustrations/estate-planning-family@640w.webp 640w, /images/illustrations/estate-planning-family@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/executors': {
    fallbackSrc: '/images/illustrations/executors@750w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/executors@320w.png 320w, /images/illustrations/executors@750w.png 750w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/executors@320w.webp 320w, /images/illustrations/executors@750w.webp 750w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/family': {
    fallbackSrc: '/images/illustrations/family@320w.png',
    sources: [
      { srcset: '/images/illustrations/family@320w.png 320w', type: 'image/png' },
      { srcset: '/images/illustrations/family@320w.webp 320w', type: 'image/webp' },
    ],
  },
  'illustrations/file': {
    fallbackSrc: '/images/illustrations/file@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/file@320w.png 320w, /images/illustrations/file@640w.png 640w, /images/illustrations/file@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/file@320w.webp 320w, /images/illustrations/file@640w.webp 640w, /images/illustrations/file@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/financing': {
    fallbackSrc: '/images/illustrations/financing@750w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/financing@320w.png 320w, /images/illustrations/financing@750w.png 750w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/financing@320w.webp 320w, /images/illustrations/financing@750w.webp 750w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/fishPet': {
    fallbackSrc: '/images/illustrations/fishPet@320w.png',
    sources: [
      { srcset: '/images/illustrations/fishPet@320w.png 320w', type: 'image/png' },
      { srcset: '/images/illustrations/fishPet@320w.webp 320w', type: 'image/webp' },
    ],
  },
  'illustrations/flower': {
    fallbackSrc: '/images/illustrations/flower@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/flower@320w.png 320w, /images/illustrations/flower@640w.png 640w, /images/illustrations/flower@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/flower@320w.webp 320w, /images/illustrations/flower@640w.webp 640w, /images/illustrations/flower@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/funeralHero': {
    fallbackSrc: '/images/illustrations/funeralHero@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/funeralHero@320w.png 320w, /images/illustrations/funeralHero@640w.png 640w, /images/illustrations/funeralHero@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/funeralHero@320w.webp 320w, /images/illustrations/funeralHero@640w.webp 640w, /images/illustrations/funeralHero@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/future-message': {
    fallbackSrc: '/images/illustrations/future-message@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/future-message@320w.png 320w, /images/illustrations/future-message@640w.png 640w, /images/illustrations/future-message@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/future-message@320w.webp 320w, /images/illustrations/future-message@640w.webp 640w, /images/illustrations/future-message@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/goodtrust-network': {
    fallbackSrc: '/images/illustrations/goodtrust-network@640w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/goodtrust-network@320w.png 320w, /images/illustrations/goodtrust-network@640w.png 640w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/goodtrust-network@320w.webp 320w, /images/illustrations/goodtrust-network@640w.webp 640w, /images/illustrations/goodtrust-network@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/hamsterPet': {
    fallbackSrc: '/images/illustrations/hamsterPet@320w.png',
    sources: [
      { srcset: '/images/illustrations/hamsterPet@320w.png 320w', type: 'image/png' },
      { srcset: '/images/illustrations/hamsterPet@320w.webp 320w', type: 'image/webp' },
    ],
  },
  'illustrations/handshake': {
    fallbackSrc: '/images/illustrations/handshake@750w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/handshake@320w.png 320w, /images/illustrations/handshake@750w.png 750w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/handshake@320w.webp 320w, /images/illustrations/handshake@750w.webp 750w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/handsOnLaptop': {
    fallbackSrc: '/images/illustrations/handsOnLaptop@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/handsOnLaptop@320w.png 320w, /images/illustrations/handsOnLaptop@640w.png 640w, /images/illustrations/handsOnLaptop@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/handsOnLaptop@320w.webp 320w, /images/illustrations/handsOnLaptop@640w.webp 640w, /images/illustrations/handsOnLaptop@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/happyDance': {
    fallbackSrc: '/images/illustrations/happyDance@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/happyDance@320w.png 320w, /images/illustrations/happyDance@640w.png 640w, /images/illustrations/happyDance@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/happyDance@320w.webp 320w, /images/illustrations/happyDance@640w.webp 640w, /images/illustrations/happyDance@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/health-agent': {
    fallbackSrc: '/images/illustrations/health-agent@320w.png',
    sources: [
      { srcset: '/images/illustrations/health-agent@320w.png 320w', type: 'image/png' },
      { srcset: '/images/illustrations/health-agent@320w.webp 320w', type: 'image/webp' },
    ],
  },
  'illustrations/horsePet': {
    fallbackSrc: '/images/illustrations/horsePet@320w.png',
    sources: [
      { srcset: '/images/illustrations/horsePet@320w.png 320w', type: 'image/png' },
      { srcset: '/images/illustrations/horsePet@320w.webp 320w', type: 'image/webp' },
    ],
  },
  'illustrations/identity': {
    fallbackSrc: '/images/illustrations/identity@750w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/identity@320w.png 320w, /images/illustrations/identity@750w.png 750w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/identity@320w.webp 320w, /images/illustrations/identity@750w.webp 750w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/life-stories': {
    fallbackSrc: '/images/illustrations/life-stories@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/life-stories@320w.png 320w, /images/illustrations/life-stories@640w.png 640w, /images/illustrations/life-stories@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/life-stories@320w.webp 320w, /images/illustrations/life-stories@640w.webp 640w, /images/illustrations/life-stories@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/locked': {
    fallbackSrc: '/images/illustrations/locked@540w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/locked@320w.png 320w, /images/illustrations/locked@540w.png 540w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/locked@320w.webp 320w, /images/illustrations/locked@540w.webp 540w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/lockedSafety': {
    fallbackSrc: '/images/illustrations/lockedSafety@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/lockedSafety@320w.png 320w, /images/illustrations/lockedSafety@640w.png 640w, /images/illustrations/lockedSafety@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/lockedSafety@320w.webp 320w, /images/illustrations/lockedSafety@640w.webp 640w, /images/illustrations/lockedSafety@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/medicalHero': {
    fallbackSrc: '/images/illustrations/medicalHero@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/medicalHero@320w.png 320w, /images/illustrations/medicalHero@640w.png 640w, /images/illustrations/medicalHero@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/medicalHero@320w.webp 320w, /images/illustrations/medicalHero@640w.webp 640w, /images/illustrations/medicalHero@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/memorialize': {
    fallbackSrc: '/images/illustrations/memorialize@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/memorialize@320w.png 320w, /images/illustrations/memorialize@640w.png 640w, /images/illustrations/memorialize@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/memorialize@320w.webp 320w, /images/illustrations/memorialize@640w.webp 640w, /images/illustrations/memorialize@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/memories': {
    fallbackSrc: '/images/illustrations/memories@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/memories@320w.png 320w, /images/illustrations/memories@640w.png 640w, /images/illustrations/memories@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/memories@320w.webp 320w, /images/illustrations/memories@640w.webp 640w, /images/illustrations/memories@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/mirror': {
    fallbackSrc: '/images/illustrations/mirror@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/mirror@320w.png 320w, /images/illustrations/mirror@640w.png 640w, /images/illustrations/mirror@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/mirror@320w.webp 320w, /images/illustrations/mirror@640w.webp 640w, /images/illustrations/mirror@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/mirrorAlt': {
    fallbackSrc: '/images/illustrations/mirrorAlt@520w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/mirrorAlt@320w.png 320w, /images/illustrations/mirrorAlt@520w.png 520w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/mirrorAlt@320w.webp 320w, /images/illustrations/mirrorAlt@520w.webp 520w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/mousePet': {
    fallbackSrc: '/images/illustrations/mousePet@320w.png',
    sources: [
      { srcset: '/images/illustrations/mousePet@320w.png 320w', type: 'image/png' },
      { srcset: '/images/illustrations/mousePet@320w.webp 320w', type: 'image/webp' },
    ],
  },
  'illustrations/oldBlackMan': {
    fallbackSrc: '/images/illustrations/oldBlackMan@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/oldBlackMan@320w.png 320w, /images/illustrations/oldBlackMan@640w.png 640w, /images/illustrations/oldBlackMan@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/oldBlackMan@320w.webp 320w, /images/illustrations/oldBlackMan@640w.webp 640w, /images/illustrations/oldBlackMan@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/parrotPet': {
    fallbackSrc: '/images/illustrations/parrotPet@320w.png',
    sources: [
      { srcset: '/images/illustrations/parrotPet@320w.png 320w', type: 'image/png' },
      { srcset: '/images/illustrations/parrotPet@320w.webp 320w', type: 'image/webp' },
    ],
  },
  'illustrations/petHero': {
    fallbackSrc: '/images/illustrations/petHero@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/petHero@320w.png 320w, /images/illustrations/petHero@640w.png 640w, /images/illustrations/petHero@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/petHero@320w.webp 320w, /images/illustrations/petHero@640w.webp 640w, /images/illustrations/petHero@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/physician': {
    fallbackSrc: '/images/illustrations/physician@320w.png',
    sources: [
      { srcset: '/images/illustrations/physician@320w.png 320w', type: 'image/png' },
      { srcset: '/images/illustrations/physician@320w.webp 320w', type: 'image/webp' },
    ],
  },
  'illustrations/poaHero': {
    fallbackSrc: '/images/illustrations/poaHero@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/poaHero@320w.png 320w, /images/illustrations/poaHero@640w.png 640w, /images/illustrations/poaHero@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/poaHero@320w.webp 320w, /images/illustrations/poaHero@640w.webp 640w, /images/illustrations/poaHero@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/printer': {
    fallbackSrc: '/images/illustrations/printer@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/printer@320w.png 320w, /images/illustrations/printer@640w.png 640w, /images/illustrations/printer@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/printer@320w.webp 320w, /images/illustrations/printer@640w.webp 640w, /images/illustrations/printer@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/property': {
    fallbackSrc: '/images/illustrations/property@1086w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/property@320w.png 320w, /images/illustrations/property@543w.png 543w, /images/illustrations/property@1086w.png 1086w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/property@320w.webp 320w, /images/illustrations/property@543w.webp 543w, /images/illustrations/property@1086w.webp 1086w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/rabbitPet': {
    fallbackSrc: '/images/illustrations/rabbitPet@320w.png',
    sources: [
      { srcset: '/images/illustrations/rabbitPet@320w.png 320w', type: 'image/png' },
      { srcset: '/images/illustrations/rabbitPet@320w.webp 320w', type: 'image/webp' },
    ],
  },
  'illustrations/raccoonPet': {
    fallbackSrc: '/images/illustrations/raccoonPet@320w.png',
    sources: [
      { srcset: '/images/illustrations/raccoonPet@320w.png 320w', type: 'image/png' },
      { srcset: '/images/illustrations/raccoonPet@320w.webp 320w', type: 'image/webp' },
    ],
  },
  'illustrations/ready': {
    fallbackSrc: '/images/illustrations/ready@640w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/ready@320w.png 320w, /images/illustrations/ready@640w.png 640w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/ready@320w.webp 320w, /images/illustrations/ready@640w.webp 640w, /images/illustrations/ready@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/review': {
    fallbackSrc: '/images/illustrations/review@520w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/review@320w.png 320w, /images/illustrations/review@520w.png 520w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/review@320w.webp 320w, /images/illustrations/review@520w.webp 520w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/rip': {
    fallbackSrc: '/images/illustrations/rip@750w.png',
    sources: [
      {
        srcset: '/images/illustrations/rip@320w.png 320w, /images/illustrations/rip@750w.png 750w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/rip@320w.webp 320w, /images/illustrations/rip@750w.webp 750w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/safe': {
    fallbackSrc: '/images/illustrations/safe@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/safe@320w.png 320w, /images/illustrations/safe@640w.png 640w, /images/illustrations/safe@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/safe@320w.webp 320w, /images/illustrations/safe@640w.webp 640w, /images/illustrations/safe@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/selectPersonWoman': {
    fallbackSrc: '/images/illustrations/selectPersonWoman@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/selectPersonWoman@320w.png 320w, /images/illustrations/selectPersonWoman@640w.png 640w, /images/illustrations/selectPersonWoman@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/selectPersonWoman@320w.webp 320w, /images/illustrations/selectPersonWoman@640w.webp 640w, /images/illustrations/selectPersonWoman@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/signatures': {
    fallbackSrc: '/images/illustrations/signatures@320w.png',
    sources: [
      { srcset: '/images/illustrations/signatures@320w.png 320w', type: 'image/png' },
      { srcset: '/images/illustrations/signatures@320w.webp 320w', type: 'image/webp' },
    ],
  },
  'illustrations/snakePet': {
    fallbackSrc: '/images/illustrations/snakePet@320w.png',
    sources: [
      { srcset: '/images/illustrations/snakePet@320w.png 320w', type: 'image/png' },
      { srcset: '/images/illustrations/snakePet@320w.webp 320w', type: 'image/webp' },
    ],
  },
  'illustrations/testament': {
    fallbackSrc: '/images/illustrations/testament@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/testament@320w.png 320w, /images/illustrations/testament@640w.png 640w, /images/illustrations/testament@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/testament@320w.webp 320w, /images/illustrations/testament@640w.webp 640w, /images/illustrations/testament@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/trusted-contact': {
    fallbackSrc: '/images/illustrations/trusted-contact@720w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/trusted-contact@360w.png 360w, /images/illustrations/trusted-contact@720w.png 720w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/trusted-contact@360w.webp 360w, /images/illustrations/trusted-contact@720w.webp 720w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/twoGirlsOneLaptop': {
    fallbackSrc: '/images/illustrations/twoGirlsOneLaptop@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/twoGirlsOneLaptop@320w.png 320w, /images/illustrations/twoGirlsOneLaptop@640w.png 640w, /images/illustrations/twoGirlsOneLaptop@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/twoGirlsOneLaptop@320w.webp 320w, /images/illustrations/twoGirlsOneLaptop@640w.webp 640w, /images/illustrations/twoGirlsOneLaptop@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/vault': {
    fallbackSrc: '/images/illustrations/vault@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/vault@320w.png 320w, /images/illustrations/vault@640w.png 640w, /images/illustrations/vault@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/vault@320w.webp 320w, /images/illustrations/vault@640w.webp 640w, /images/illustrations/vault@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/vault-2': {
    fallbackSrc: '/images/illustrations/vault-2@720w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/vault-2@360w.png 360w, /images/illustrations/vault-2@720w.png 720w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/vault-2@360w.webp 360w, /images/illustrations/vault-2@720w.webp 720w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/vet': {
    fallbackSrc: '/images/illustrations/vet@320w.png',
    sources: [
      { srcset: '/images/illustrations/vet@320w.png 320w', type: 'image/png' },
      { srcset: '/images/illustrations/vet@320w.webp 320w', type: 'image/webp' },
    ],
  },
  'illustrations/vetTall': {
    fallbackSrc: '/images/illustrations/vetTall@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/vetTall@320w.png 320w, /images/illustrations/vetTall@640w.png 640w, /images/illustrations/vetTall@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/vetTall@320w.webp 320w, /images/illustrations/vetTall@640w.webp 640w, /images/illustrations/vetTall@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/what': {
    fallbackSrc: '/images/illustrations/what@889w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/what@320w.png 320w, /images/illustrations/what@889w.png 889w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/what@320w.webp 320w, /images/illustrations/what@889w.webp 889w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/willHero': {
    fallbackSrc: '/images/illustrations/willHero@960w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/willHero@320w.png 320w, /images/illustrations/willHero@640w.png 640w, /images/illustrations/willHero@960w.png 960w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/willHero@320w.webp 320w, /images/illustrations/willHero@640w.webp 640w, /images/illustrations/willHero@960w.webp 960w',
        type: 'image/webp',
      },
    ],
  },
  'illustrations/witness': {
    fallbackSrc: '/images/illustrations/witness@750w.png',
    sources: [
      {
        srcset:
          '/images/illustrations/witness@320w.png 320w, /images/illustrations/witness@750w.png 750w',
        type: 'image/png',
      },
      {
        srcset:
          '/images/illustrations/witness@320w.webp 320w, /images/illustrations/witness@750w.webp 750w',
        type: 'image/webp',
      },
    ],
  },
}
